// eslint-disable-next-line max-len
export const UUIDPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function validateUUID(value: string): boolean {
  return UUIDPattern.test(value);
}
